import React, { ChangeEvent, useState } from 'react';

type InputTextAreaAutosizeProps = {
  value: string;
  onChange: (value: string) => void;
  width?: string;
  height?: string;
  m?: string;
  resize?: 'none' | 'vertical' | 'horizontal'
};

const InputTextAreaAutosize: React.FC<InputTextAreaAutosizeProps> = (props) => {
  const [focused, setFocused] = useState(false);
  const [hovered, setHovered] = useState(false);

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange(event.target.value);
  };

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <textarea
      name='note'
      rows={4}
      cols={40}
      value={props.value}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        padding: '8.5px 12px',
        borderRadius: '4px',
        borderColor: focused ? '#23B7E5' : (hovered ? '#212121' : '#BDBDBD'),
        borderWidth: '1px',
        borderStyle: 'solid',
        resize: props.resize ? props.resize : 'none',
        fontSize: '14px',
        fontWeight: 400,
        outline: 'none',
        margin: props.m,
        width: props.width,
        height: props.height
      }}
    />
  );
};

export default InputTextAreaAutosize;
